import React from 'react'
import { makeStyles, Box, Divider, useMediaQuery, useTheme } from '@material-ui/core'
import InfoItem from 'src/mobile/components/Order/InfoItem'
import { useTranslation } from 'react-i18next'
import { SERVICE_PHONE_02 } from 'src/utils/constant'
import { ReactComponent as StepOne } from '../assets/icons/step_info_1.svg'
import { ReactComponent as StepTwo } from '../assets/icons/step_info_2.svg'
import { ReactComponent as StepThree } from '../assets/icons/step_info_3.svg'
import { ReactComponent as Arrow } from '../assets/icons/arrow_right.svg'

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: 106,
    marginRight: 106,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  step: {
    display: 'flex',
    maxWidth: '644px',
    justifyContent: 'space-between',
    // alignItems: 'center',
    borderRadius: '24px',
    marginTop: 24,
  },
  stepBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: theme.spacing(2),
  },
  arrow: {
    margin: 'auto 0',
  },
  infoItem: {
    fontSize: 16,
    '& .MuiBox-root': {
      fontSize: 16,
      color: '#4B5563',
    },
  },
  infoItemText: {
    fontSize: 16,
    display: 'flex',
  },
}))

const BookingInfo = ({ product }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()
  const { t } = useTranslation()
  const ItemDot = () => (
    <Box color="grey.900" mr={1} component="span">
      •
    </Box>
  )
  return (
    <Box className={classes.root}>
      <Box fontSize={20} fontWeight={600} my={2}>
        {t('tips.main_tips')}{' '}
      </Box>
      <Box pb={2} mb={2} className={classes.infoItem}>
        <Box>
          {product === 3 || product === 4 || product === 5 ? (
            <InfoItem
              NoJustify
              value={
                <Box className={classes.infoItemText}>
                  <ItemDot />
                  {t('tips.appointment_tips_list.13')}
                </Box>
              }
            />
          ) : (
            <InfoItem
              NoJustify
              value={
                <Box className={classes.infoItemText}>
                  <ItemDot />
                  {t('tips.appointment_tips_list.7')}
                </Box>
              }
            />
          )}

          <InfoItem
            NoJustify
            value={
              <Box className={classes.infoItemText}>
                <ItemDot />
                {t('tips.appointment_tips_list.3')}
              </Box>
            }
          />
          <InfoItem
            NoJustify
            value={
              <Box className={classes.infoItemText}>
                <ItemDot />
                {t('tips.appointment_tips_list.8')}
              </Box>
            }
          />
          <InfoItem
            NoJustify
            value={
              <Box className={classes.infoItemText}>
                <ItemDot />
                {t('tips.appointment_tips_list.9', { phone: SERVICE_PHONE_02 })}
              </Box>
            }
          />
          <InfoItem
            NoJustify
            value={
              <Box className={classes.infoItemText}>
                <ItemDot />
                {t('tips.appointment_tips_list.5', { phone: SERVICE_PHONE_02 })}
              </Box>
            }
          />
        </Box>
      </Box>
      <Divider />
      <Box fontSize={20} fontWeight={600} my={2} mt={isMobile ? 4 : 5}>
        {t('productPage.NPC.booking_help')}
      </Box>
      <Box display={!isMobile ? 'flex' : ''} mb={4}>
        <Box mr={!isMobile ? '20px' : ''}>
          <Box fontSize={16} fontWeight={600} mt={3} mb={2}>
            {t('common.update_booking')}
          </Box>
          <Box color="#4B5563" lineHeight={1.5} fontSize={16}>
            {t('productPage.NPC.help.1', { phone: SERVICE_PHONE_02 })}
          </Box>
        </Box>
        <Box mr={!isMobile ? '20px' : ''}>
          <Box fontSize={16} fontWeight={600} mt={3} mb={2}>
            {t('productPage.NPC.automatic_notify')}
          </Box>
          <Box color="#4B5563" lineHeight={1.5} fontSize={16}>
            {t('productPage.NPC.help.2')}
          </Box>
        </Box>
        <Box mb={3}>
          <Box fontSize={16} fontWeight={600} mt={3} mb={2}>
            {t('productPage.NPC.privacy')}
          </Box>
          <Box color="#4B5563" lineHeight={1.5} fontSize={16}>
            {t('productPage.NPC.help.3')}
          </Box>
        </Box>
      </Box>
      <Divider />
      <Box fontSize={20} fontWeight={600} my={2} mt={isMobile ? 4 : 5}>
        {t('productPage.NPC.steps_check')}
      </Box>
      <Box color="#4B5563" lineHeight={1.5} fontSize={16}>
        {t('productPage.NPC.check_intro')}
      </Box>
      <Box
        className={classes.step}
        mt={isMobile ? 0 : 5}
        mb={isMobile ? 3 : 13}
        // px={3}
        border={isMobile ? 'none' : '1px solid #E5E7EB'}
      >
        <Box className={classes.stepBox}>
          <Box mt={2}>
            <StepOne />
          </Box>
          <Box my={2} width={isMobile ? 80 : 180}>
            {t('productPage.service.circle.1')}
          </Box>
        </Box>
        <Arrow className={classes.arrow} />
        <Box className={classes.stepBox}>
          <Box mt={2}>
            <StepTwo />
          </Box>
          <Box my={2} width={isMobile ? 80 : 180}>
            {t('productPage.NPC.step_2')}
          </Box>
        </Box>
        <Arrow className={classes.arrow} />
        <Box
          className={classes.stepBox}
          // pt={isMobile ? 3 : 0}
        >
          <Box mt={2}>
            <StepThree />
          </Box>
          <Box my={2} width={isMobile ? 80 : 180}>
            {t('productPage.NPC.special.6')}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default BookingInfo
